import React from 'react';
import { colors } from '../../config/colors';
import { Card } from './card';

const shimmerBg = {
  backgroundImage: `linear-gradient(90deg, ${colors.gray[200]} 0%, ${colors.gray[100]} 45%, ${colors.gray[50]} 50%, ${colors.gray[100]} 55%, ${colors.gray[200]} 100%)`,
  backgroundSize: '200% 100%',
};

const ShimmerBlock = ({ className = '', style = {} }) => (
  <div
    className={`animate-shimmer rounded ${className}`}
    style={{ ...shimmerBg, ...style }}
  />
);

const TableShimmer = ({ rows = 8, cardStyle = {} }) => (
  <Card className="p-6 overflow-hidden" style={cardStyle}>
    <div className="overflow-x-auto rounded-lg border" style={{ borderColor: colors.border.light }}>
      <table className="w-full">
        <thead>
          <tr className="border-b" style={{ borderColor: colors.border.light }}>
            {[1, 2, 3, 4, 5, 6, 7].map((i) => (
              <th key={i} className="px-4 py-3 text-left">
                <ShimmerBlock className="h-4" style={{ width: i === 1 ? 120 : i === 7 ? 100 : 80 }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx} className="border-b" style={{ borderColor: colors.border.light }}>
              <td className="px-4 py-3">
                <div className="flex items-center gap-3">
                  <ShimmerBlock className="w-10 h-10 rounded-full shrink-0" />
                  <div className="space-y-1">
                    <ShimmerBlock className="h-4" style={{ width: 100 }} />
                    <ShimmerBlock className="h-3" style={{ width: 60 }} />
                  </div>
                </div>
              </td>
              {[2, 3, 4, 5, 6].map((i) => (
                <td key={i} className="px-4 py-3">
                  <ShimmerBlock
                    className="h-4"
                    style={{ width: i === 2 ? 100 : i === 4 ? 80 : 70 }}
                  />
                </td>
              ))}
              <td className="px-4 py-3">
                <div className="flex gap-2">
                  <ShimmerBlock className="h-8 w-8" />
                  <ShimmerBlock className="h-8 w-8" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);

export { TableShimmer };
